/**
 * author: Ananthapadmanabhan V K
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { LS_ACCESS_TOKEN_KEY } from "../core/constants/common";

const SubAdminRoute = ({ children }) => {
  if (localStorage.getItem(LS_ACCESS_TOKEN_KEY)) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
}

export default SubAdminRoute;